import { BOGeneralValues } from "./BOGeneralValues.model";
import { BOPayTypeSellDetail } from "./BOPayTypeSellDetail.model";
import { BOSellDetail } from "./BOSellDtail.model";

export class BOSell extends BOGeneralValues{


    id?:number;
    documentNumber?:string;
    documentNumberInt?:number;
    invoiceTypeId?:number;
    invoiceTypeName?:string;
    total?:number;
    dateSell?:Date | undefined;
    userId? :number;
    userIdString?:string;
    userName?:string;
    userEmail?:string;
    observations?:string;
    clinicHistoryId?:number;
    idTypeIdentification?:number;
    sellDetails?:BOSellDetail[]=[];
    payTypeSellDetails?:BOPayTypeSellDetail[]=[];
    sellIdTemp?:number;
    areaId?:number;
    url?:string;
}
